import { render, staticRenderFns } from "./EdgecasterOutputs.vue?vue&type=template&id=a8d8b4f2"
import script from "./EdgecasterOutputs.vue?vue&type=script&lang=js"
export * from "./EdgecasterOutputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports